const progressColorList = [
  {
    color: "#CF3E00",
    max: 15,
  },
  {
    color: "#E28B66",
    max: 30,
  },
  {
    color: "#FEB886",
    max: 50,
  },
  {
    color: "#FBDB14",
    max: 60,
  },
  {
    color: "#A7C933",
    max: 80,
  },
  {
    color: "#7DCEA0",
    max: 90,
  },
  {
    color: "#27AE60",
    max: 100,
  },
];

export const getProgressBarColor = (score: number) => {
  const progress = progressColorList.find(({ max }) => max >= score);
  return progress?.color ?? "#D4D4D4";
};
